import { useQuery } from '@tanstack/react-query';
import { fetchBusiness } from './request';
import { BUSINESS_QUERY_KEY } from './key';

export const useBusiness = () => {
  return useQuery({
    queryKey: [BUSINESS_QUERY_KEY],
    queryFn: fetchBusiness,
  });
};
